export default __webpack_public_path__ + "static/media/socialTwitterdark.0966a688.svg";